import React, { useState, useEffect } from 'react';
import { makeStyles, TextField } from '@material-ui/core';
import { DialogContentText } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import { toast } from 'react-toastify';
import { dataService } from '../../Services/data.service';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { productTypeRawMaterial,productTypeAdditive} from '../../Config/constants'

export default function SwitchRawMaterialDialog(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const [switchPercentage, setSwitchPercentage] = useState(100);
    const [originalRawMaterial, setOriginalRawMaterial] = useState([]);

    const BOMRows = originalRawMaterial.filter(x => {
        let metaData = JSON.parse(x.bomMetaData)
        return metaData.find(y => y.MetaDataType === 1).MetaData[0].ProductType === productTypeAdditive || metaData.find(y => y.MetaDataType === 1).MetaData[0].ProductType === productTypeRawMaterial
    }).map(m => {     
        let percentage = JSON.parse(m.bomMetaData).find(y => y.MetaDataType === 1).MetaData[0].Percentage
        return createBOMData(m.productReference, m.productDescription, m.quantityToConsume, percentage, m.uom)
    })

    function createBOMData(productReference, productDescription, quantity, percentage, uom) {
        return { productReference, productDescription, quantity, percentage ,uom};
    }

    useEffect(() => {
        dataService.GetOriginalRawMaterialBoms(props.rawMaterialSwitchOrderId).then(boms => {
            setOriginalRawMaterial(boms)
        }).catch((error) => { toast.error(error, { position: "top-center" }) })
    }, [props.rawMaterialSwitchOrderId]);

    const changePercentage = (event) => {
        let tempVal = Math.floor(event.target.value)
        if(tempVal > 100) 
        {
            tempVal = 100
        }

        if(tempVal <= 0) 
        {
            tempVal = 0
        }

        setSwitchPercentage(tempVal);
    }

    return (
        <Dialog className={classes.dialogContainer}
            open={props.dialogOpen}
            onClose = {() => props.closeDialog()}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle className={classes.dialogTitle} id="draggable-dialog-title">
                {t('RawMaterialReplacement')}{props.rawMaterialSwitchOrderReference}
            </DialogTitle>
            <DialogContent >
                <DialogContentText className={classes.dialogContext}>
                    {
                        props.rawMaterialSwitchDefaultSilo === "-" && <TextField value={switchPercentage} id="outlined-search" label={t('Percentage')} min={0} max={100} step={1} type="number" variant="outlined" className={classes.percentageTextField} onChange={(e) => changePercentage(e)} />
                    }
                    {
                        props.rawMaterialSwitchDefaultSilo !== "-" && <React.Fragment>
                                <div className={classes.originalText}>{t('UseOriginal')}</div>

                                <TableContainer component={Paper} className={classes.paper}>
                                    <Table className={classes.table} aria-label="customized table">
                                        <TableBody>
                                            <TableRow key={'headerRow'} className={classes.headerRow}>
                                                <TableCell className={classes.nameCell}>
                                                    {t('productReference')}
                                                </TableCell>
                                                <TableCell className={classes.nameCell}>
                                                    {t('productDescription')}
                                                </TableCell>
                                                <TableCell className={classes.nameCell}>
                                                    {t('quantityToConsume')}
                                                </TableCell>
                                                <TableCell className={classes.nameCell}>
                                                    {t('Percent')}
                                                </TableCell>
                                            </TableRow>
                                            {BOMRows.map((row) => (
                                                <TableRow key={row.name} className={classes.row}>
                                                    <TableCell className={classes.nameCell}>
                                                        {t(row.productReference)}
                                                    </TableCell>
                                                    <TableCell className={classes.nameCell}>
                                                        {t(row.productDescription)}
                                                    </TableCell>
                                                    <TableCell className={classes.nameCell}>
                                                        {t(parseFloat(row.quantity).toFixed(3))}{" "}{t(row.uom)}
                                                    </TableCell>
                                                    <TableCell className={classes.nameCell}>
                                                        {t(parseFloat(row.percentage).toFixed(2))}{" "}{"%"}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </React.Fragment>
                    }
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <div className={classes.buttons}>
                    <Button className={classes.cancelButton} autoFocus onClick={() => props.closeDialog()}>
                        {t('CANCEL')}
                    </Button>
                    <Button className={classes.okButton} onClick={() => {
                        const hasReplacementMaterial = props.rawMaterialSwitchDefaultSilo === "-";
                        props.switchRawMaterial(props.rawMaterialSwitchOrderId, switchPercentage, hasReplacementMaterial);
                    }}>
                        {props.rawMaterialSwitchDefaultSilo === "-" && t('SAVE')}
                        {props.rawMaterialSwitchDefaultSilo !== "-" && t('TERUGZETTEN')}
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
}


const useStyles = makeStyles(() => ({

    dialogContainer: {
        width: "1200px !important",
        height: "1000px !important",
        maxWidth: "1200px !important",
        maxHeight: "1000px !important",
        margin: "auto"
    },
    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        '& h2': {
            fontSize: "32px !important",
        },
        paddingTop: "20px",
        cursor: 'move'
    },
    dialogContext: {
        color: "#000000",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        paddingBottom: "20px"
    },
    paper: {
        width: "1200px !important",
        boxShadow: 'none'
    },
    okButton: {
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        backgroundColor: FlagstoneTheme.palette.primary.main,
        '&:hover': {
            backgroundColor: FlagstoneTheme.palette.primary.main,
        },
        margin: "3px",
        marginBottom: "20px"
    },
    cancelButton: {
        color: FlagstoneTheme.palette.primary.main,
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        backgroundColor: "#E6E8FE",
        '&:hover': {
            backgroundColor: "#E6E8FE",
        },
        margin: "3px",
        marginBottom: "20px"
    },
    buttons: {
        width: "100%",
        textAlign: "center"
    },
    percentageTextField : {
        backgroundColor: "white",
        borderRadius: "4px",
        boxSizing: "border-box",
        width: "100%"
    },
    nameCell: {
        padding: "3px !important",
        border: "none",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        width: "120px"
    },
    headerRow: {
        backgroundColor: "#F4F4F4",
        border: "1px solid #ddd"
    },
    row: {
        border: "1px solid #ddd"
    },
    originalText: {
        marginBottom: "20px"
    }
}));
